<script lang="ts">
    import img1 from './images/victory_day_banner_1920.png';
    import img2 from './images/victory_day_banner_390.png';
</script>

<div class="sticky top-0 z-20 w-auto items-center">
    <img
        src={img1}
        alt=""
        class="w-full hidden sm:block"
    />
    
    <img
        src={img2}
        alt=""
        class="w-full sm:hidden"
    />
</div>